import { Component, EventEmitter, Output, Input } from '@angular/core';
import { NoteUpd } from '../../shared/models/NoteUpd';
import { ConfirmOutput } from '../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../shared/enums/CPDialogResult';
import { CRUDActions } from '../../shared/enums/CRUDActions';
import { CommonFunctions } from '../../shared/static/common-functions';
import { BaseMessageInfo } from '../../shared/models/BaseMessageInfo';
import { MessageInfo } from '../../shared/models/MessageInfo';
import { GlobalsService } from '../../shared/services/globals.service';
import { DispatchAssignmentBus } from '@app/cp/shared/models/DispatchAssignmentBus';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { v_DispatchAssignmentBus } from '@app/cp/shared/models/v_DispatchAssignmentBus';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { GItem } from '../../shared/models/GItem';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { DateFunctions } from '@app/cp/shared/static/date-functions';

@Component({
    selector: 'dispatch-change-assignment-dialog',
    templateUrl: './dispatch-change-assignment-dialog.component.html',
    styleUrls: ['./dispatch-change-assignment-dialog.component.scss'],
    standalone: false
})
export class DispatchChangeAssignmentDialogComponent  {

    constructor(globals: GlobalsService, private svc_data: DispatchesService) {

    }
    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };

    active: boolean = false;
    data: any;
    gridData: v_DispatchAssignmentBus[];
    action: CRUDActions;
    techId: string;
    assignmentDateTime: Date;
    code: string;
    @Input() title: string;
    @Input() message: string;
    @Output() confirmation: EventEmitter<ConfirmOutput> = new EventEmitter<ConfirmOutput>();
    @Input() sublings: GItem[] =[];
    statusList: GItem[] = []
    hide() {
        this.active = false;
        this.data = null;
        this.title = null;
        this.message = null;
        this.action = CRUDActions.None;

    }
    ok() {
        this.assignmentDateTime = DateFunctions.getDateNow();
        let result: ConfirmOutput = {
            action: this.action, dialogResult: CPDialogResult.ok, data: { techId: this.techId, assignmentDateTime: this.assignmentDateTime}, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    cancel() {
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.cancel, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    close() {
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.close, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    public show(id: any) {

        this.active = true;

    }
}

